import { GetAuthToken } from '../../contexts/AuthContext';
import { isDevelopment } from '../../helpers/environment/isDevelopment';

import { returnResponseOrThrow, JSON_HEADERS, post } from './shared';

export const validateRecaptcha = async (
  token: string,
  keyType: 'mykiss_invisible' | 'mykiss_checkbox',
  getAuthToken: GetAuthToken,
): Promise<Response> => {
  if (isDevelopment()) {
    return Promise.resolve({ ok: true } as Response);
  }
  return post(
    '/captcha_verifications',
    getAuthToken,
    false,
    { captcha_response: token, key_type: keyType },
    JSON_HEADERS,
  ).then(returnResponseOrThrow);
};
